var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.moduleData.cover)?_c('div',{staticClass:"common-top",class:{
  isMobile: _vm.isMobile()
},style:(`background: url(${_vm.moduleData.cover.url}) no-repeat; background-size: 100% 100%;`)},[_c('div',{class:`sys-max-width`},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.moduleData.name))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }